import * as React from "react";

import Form, { FormComponentProps } from "@ant-design/compatible/es/form";
import FormCard from "@impero-com/common/components/formCard";
import FormCardContainer from "@impero-com/common/components/formCardContainer";
import { AjaxManager } from "@impero-com/common/utils/ajax";
import { t } from "@impero-com/common/utils/i18n";
import { Button, CardFooter, FormTitle, FormSubtitle } from "@impero-com/ui";
import { Input } from "antd";
import { Link } from "react-router-dom";

import { postEnterOrg } from "api/generated/authentication/authentication";
import { RedirectTarget } from "api/generated/model";

import { storeLastChosenOrg } from "../utils/storage/lastChosenOrg";

import RightSideText from "./rightSideText";

const FormItem = Form.Item;

class TeamLogin extends React.Component<TeamLoginProps, TeamLoginState> {
    constructor(props: TeamLoginProps) {
        super(props);
        this.state = {
            status: { type: "DEFAULT" },
        };
    }

    handleSubmit = (e: React.FormEvent<any>) => {
        e.preventDefault();
        this.props.form.validateFields((err: any, values: TeamLoginProps) => {
            if (!err) {
                let { organization } = values;
                if (organization === undefined) {
                    throw new Error(t("Login_OrgUndefinedError"));
                }
                organization = organization.toLowerCase();
                const { ajaxManager } = this.props;
                ajaxManager
                    .ajax<RedirectTarget, TeamLoginStatus>(
                        () =>
                            postEnterOrg({
                                org_short_name: organization,
                            }),
                        {
                            component: this,
                            initialStatusValue: "DEFAULT",
                            getErrorStatus: () => ({ type: "DEFAULT" }),
                            getSuccessStatus: () => ({ type: "DEFAULT" }),
                            inFlightStatus: { type: "LOGGING_IN" },
                            onErrorCode: {
                                404: () => {
                                    this.props.form.validateFields(
                                        (err: any) => {
                                            if (!err) {
                                                this.props.form.setFields({
                                                    organization: {
                                                        value: organization,
                                                        errors: [
                                                            new Error(
                                                                t(
                                                                    "Login_OrgNotRecognizedError"
                                                                )
                                                            ),
                                                        ],
                                                    },
                                                });
                                            }
                                        }
                                    );
                                },
                            },
                        }
                    )
                    .then((response: RedirectTarget) => {
                        const { redirect } = response;
                        storeLastChosenOrg(organization);
                        window.location.href = this.props.redirectPath
                            ? new URL(this.props.redirectPath, redirect).href
                            : redirect;
                    });
            }
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <FormCardContainer rightSide={<RightSideText />}>
                <FormTitle title={t("Login_SignInOrganization")} />
                <FormSubtitle subtitle={t("Login_SignInOrgDescription")} />
                <FormCard onSubmitForm={this.handleSubmit}>
                    <FormItem>
                        {getFieldDecorator("organization", {
                            rules: [
                                {
                                    required: true,
                                    message: t(
                                        "LoginFlow_PleaseEnterOrganizationName"
                                    ),
                                },
                            ],
                        })(
                            <Input
                                addonAfter=".impero.com"
                                placeholder={t("Login_YourOrganization")}
                            />
                        )}
                    </FormItem>
                    <FormItem>
                        <Button
                            id="loginFormSubmitBtn"
                            variant="primary"
                            type="submit"
                            loading={this.state.status.type === "LOGGING_IN"}
                            block
                        >
                            {t("Login_ContinueButton")}
                        </Button>
                    </FormItem>
                </FormCard>

                <CardFooter>
                    <Link to="/forgot">
                        {t("LoginFlow_ForgotYourTeamName")}
                    </Link>
                </CardFooter>
            </FormCardContainer>
        );
    }
}

const TeamLoginWrapped = Form.create<TeamLoginProps>()(TeamLogin);

export default TeamLoginWrapped;

interface TeamLoginProps extends FormComponentProps {
    organization?: string;
    ajaxManager: AjaxManager;
    redirectPath?: string;
}

type TeamLoginStatus = { type: "DEFAULT" } | { type: "LOGGING_IN" };
interface TeamLoginState {
    status: TeamLoginStatus;
}
